module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point02-55d20c62881c6bfe4893152a1dcfe418.png";